(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './supabase-kt-supabase-kt.js', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlinx-serialization-kotlinx-serialization-json.js', './ktor-ktor-client-core.js', './supabase-kt-auth-kt.js', './ktor-ktor-http.js', './ktor-ktor-utils.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./supabase-kt-supabase-kt.js'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./ktor-ktor-client-core.js'), require('./supabase-kt-auth-kt.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-utils.js'));
  else {
    if (typeof globalThis['supabase-kt-supabase-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'supabase-kt-supabase-kt' was not found. Please, check whether 'supabase-kt-supabase-kt' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['supabase-kt-auth-kt'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'supabase-kt-auth-kt' was not found. Please, check whether 'supabase-kt-auth-kt' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'supabase-kt-postgrest-kt'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'supabase-kt-postgrest-kt'.");
    }
    globalThis['supabase-kt-postgrest-kt'] = factory(typeof globalThis['supabase-kt-postgrest-kt'] === 'undefined' ? {} : globalThis['supabase-kt-postgrest-kt'], globalThis['supabase-kt-supabase-kt'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['ktor-ktor-client-core'], globalThis['supabase-kt-auth-kt'], globalThis['ktor-ktor-http'], globalThis['ktor-ktor-utils']);
  }
}(function (_, kotlin_io_github_jan_tennert_supabase_supabase_kt, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_ktor_ktor_client_core, kotlin_io_github_jan_tennert_supabase_auth_kt, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_utils) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var MainConfig = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.q;
  var VOID = kotlin_kotlin.$_$.d;
  var Companion_getInstance = kotlin_kotlin.$_$.d3;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration = kotlin_kotlin.$_$.tm;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var toString = kotlin_kotlin.$_$.hh;
  var Duration__toString_impl_8d916b = kotlin_kotlin.$_$.o;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var hashCode = kotlin_kotlin.$_$.bg;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var Duration__hashCode_impl_u4exz6 = kotlin_kotlin.$_$.g;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Companion_getInstance_0 = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.c;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var setup = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.u;
  var SupabasePluginProvider = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.v;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var MainPlugin = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.s;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var isInterface = kotlin_kotlin.$_$.rg;
  var getKClass = kotlin_kotlin.$_$.si;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var JsonElementSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.b;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var SerializableWith = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w2;
  var _Duration___get_inWholeMilliseconds__impl__msfiry = kotlin_kotlin.$_$.i;
  var timeout = kotlin_io_ktor_ktor_client_core.$_$.p;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var bodyAsText = kotlin_io_ktor_ktor_client_core.$_$.f;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var get_supabaseJson = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.a1;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f3;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var LogLevel_INFO_getInstance = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.f;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x2;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var authenticatedSupabaseApi = kotlin_io_github_jan_tennert_supabase_auth_kt.$_$.g;
  var resolveUrl = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.r;
  var init = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.t;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.i4;
  var first = kotlin_kotlin.$_$.o9;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  var RestException = kotlin_io_github_jan_tennert_supabase_supabase_kt.$_$.k;
  var trimIndent = kotlin_kotlin.$_$.km;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var contentType = kotlin_io_ktor_ktor_http.$_$.o1;
  var joinToString = kotlin_kotlin.$_$.aa;
  var listOf = kotlin_kotlin.$_$.sa;
  var parametersOf = kotlin_io_ktor_ktor_http.$_$.y1;
  var JsonElement = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var isBlank = kotlin_kotlin.$_$.dk;
  var header = kotlin_io_ktor_ktor_client_core.$_$.u;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.h;
  var Enum = kotlin_kotlin.$_$.en;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.j4;
  var HeadersBuilder = kotlin_io_ktor_ktor_http.$_$.x;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var KtList = kotlin_kotlin.$_$.e7;
  var Pair = kotlin_kotlin.$_$.pn;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var replace = kotlin_kotlin.$_$.xk;
  var Collection = kotlin_kotlin.$_$.y6;
  var contains = kotlin_kotlin.$_$.nj;
  var listOf_0 = kotlin_kotlin.$_$.ta;
  var toMap = kotlin_kotlin.$_$.nc;
  var emptyList = kotlin_kotlin.$_$.c9;
  var plus = kotlin_kotlin.$_$.ib;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.f;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Config, 'Config', Config, MainConfig);
  initMetadataForCompanion(Companion, VOID, [SupabasePluginProvider]);
  initMetadataForInterface(Postgrest, 'Postgrest', VOID, VOID, [MainPlugin], [2, 3, 1, 0]);
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PostgrestErrorResponse, 'PostgrestErrorResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCoroutine($parseErrorResponseCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PostgrestImpl, 'PostgrestImpl', VOID, VOID, [Postgrest], [1, 3, 2, 0]);
  initMetadataForInterface(PropertyConversionMethod, 'PropertyConversionMethod');
  initMetadataForClass(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0, 'sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0', VOID, VOID, [PropertyConversionMethod, FunctionAdapter]);
  initMetadataForClass(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0, 'sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0', VOID, VOID, [PropertyConversionMethod, FunctionAdapter]);
  initMetadataForClass(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1, 'sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0', VOID, VOID, [PropertyConversionMethod, FunctionAdapter]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(PostgrestRestException, 'PostgrestRestException', VOID, RestException);
  initMetadataForCoroutine($asPostgrestResultCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($executeCOROUTINE$, CoroutineImpl);
  initMetadataForObject(RestRequestExecutor, 'RestRequestExecutor', VOID, VOID, VOID, [3]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(Columns, 'Columns');
  initMetadataForClass(Order, 'Order', VOID, Enum);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(PostgrestQueryBuilder, 'PostgrestQueryBuilder', VOID, VOID, VOID, [2, 1]);
  initMetadataForClass(Returning, 'Returning');
  initMetadataForObject(Minimal, 'Minimal', VOID, Returning);
  initMetadataForClass(Representation, 'Representation', Representation, Returning);
  initMetadataForClass(PostgrestRequestBuilder, 'PostgrestRequestBuilder');
  initMetadataForClass(FilterOperation, 'FilterOperation');
  initMetadataForClass(FilterOperator, 'FilterOperator', VOID, Enum);
  initMetadataForClass(PostgrestFilterBuilder, 'PostgrestFilterBuilder');
  initMetadataForClass(InsertRequestBuilder, 'InsertRequestBuilder', VOID, PostgrestRequestBuilder);
  initMetadataForClass(SelectRequestBuilder, 'SelectRequestBuilder', VOID, PostgrestRequestBuilder);
  initMetadataForClass(UpsertRequestBuilder, 'UpsertRequestBuilder', VOID, InsertRequestBuilder);
  function get_body() {
    return null;
  }
  function get_headers() {
    return Companion_getInstance_2().yt1_1;
  }
  function get_returning() {
    return Minimal_getInstance();
  }
  initMetadataForInterface(PostgrestRequest, 'PostgrestRequest');
  initMetadataForClass(DeleteRequest, 'DeleteRequest', VOID, VOID, [PostgrestRequest]);
  initMetadataForClass(InsertRequest, 'InsertRequest', VOID, VOID, [PostgrestRequest]);
  initMetadataForClass(SelectRequest, 'SelectRequest', VOID, VOID, [PostgrestRequest]);
  initMetadataForClass(UpdateRequest, 'UpdateRequest', VOID, VOID, [PostgrestRequest]);
  initMetadataForClass(PostgrestResult, 'PostgrestResult');
  //endregion
  function Config(defaultSchema, propertyConversionMethod, requireValidSession, urlLengthLimit, timeout) {
    defaultSchema = defaultSchema === VOID ? 'public' : defaultSchema;
    propertyConversionMethod = propertyConversionMethod === VOID ? Companion_getInstance_5().iwu_1 : propertyConversionMethod;
    requireValidSession = requireValidSession === VOID ? false : requireValidSession;
    urlLengthLimit = urlLengthLimit === VOID ? 8000 : urlLengthLimit;
    var tmp;
    if (timeout === VOID) {
      // Inline function 'kotlin.time.Companion.seconds' call
      Companion_getInstance();
      tmp = toDuration(30, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = timeout;
    }
    timeout = tmp;
    MainConfig.call(this);
    this.mwu_1 = defaultSchema;
    this.nwu_1 = propertyConversionMethod;
    this.owu_1 = requireValidSession;
    this.pwu_1 = urlLengthLimit;
    this.qwu_1 = timeout;
    this.rwu_1 = null;
  }
  protoOf(Config).tvz = function () {
    return this.owu_1;
  };
  protoOf(Config).toString = function () {
    return 'Config(defaultSchema=' + this.mwu_1 + ', propertyConversionMethod=' + toString(this.nwu_1) + ', requireValidSession=' + this.owu_1 + ', urlLengthLimit=' + this.pwu_1 + ', timeout=' + Duration__toString_impl_8d916b(this.qwu_1) + ')';
  };
  protoOf(Config).hashCode = function () {
    var result = getStringHashCode(this.mwu_1);
    result = imul(result, 31) + hashCode(this.nwu_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.owu_1) | 0;
    result = imul(result, 31) + this.pwu_1 | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.qwu_1) | 0;
    return result;
  };
  protoOf(Config).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Config))
      return false;
    if (!(this.mwu_1 === other.mwu_1))
      return false;
    if (!equals(this.nwu_1, other.nwu_1))
      return false;
    if (!(this.owu_1 === other.owu_1))
      return false;
    if (!(this.pwu_1 === other.pwu_1))
      return false;
    if (!equals(this.qwu_1, other.qwu_1))
      return false;
    return true;
  };
  function Companion() {
    Companion_instance = this;
    this.swu_1 = 'rest';
    this.twu_1 = Companion_getInstance_0().ovj('Supabase-PostgREST');
    this.uwu_1 = 1;
  }
  protoOf(Companion).t1 = function () {
    return this.swu_1;
  };
  protoOf(Companion).vwu = function (init) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    init(this_0);
    return this_0;
  };
  protoOf(Companion).ovl = function (init) {
    return this.vwu(init);
  };
  protoOf(Companion).wwu = function (supabaseClient, config) {
    return new PostgrestImpl(supabaseClient, config);
  };
  protoOf(Companion).xvk = function (supabaseClient, config) {
    return this.wwu(supabaseClient, config instanceof Config ? config : THROW_CCE());
  };
  var Companion_instance;
  function Companion_getInstance_3() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function Postgrest() {
  }
  function get_postgrest(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_3();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Postgrest) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Postgrest).o() + '. Consider installing ' + getKClass(Postgrest).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  }
  function from(_this__u8e3s4, table) {
    var tmp0 = _this__u8e3s4.tvj();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPlugin' call
    var provider = Companion_getInstance_3();
    // Inline function 'io.github.jan.supabase.plugins.PluginManager.getPluginOrNull' call
    var tmp = tmp0.wvk_1.w2(provider.t1());
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Postgrest) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Plugin ' + provider.t1() + ' not installed or not of type ' + getKClass(Postgrest).o() + '. Consider installing ' + getKClass(Postgrest).o() + ' within your SupabaseClientBuilder';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0.xwu(table);
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.github.jan.supabase.postgrest.PostgrestErrorResponse', this, 4);
    tmp0_serialDesc.a7c('message', false);
    tmp0_serialDesc.a7c('hint', true);
    tmp0_serialDesc.a7c('details', true);
    tmp0_serialDesc.a7c('code', true);
    this.ywu_1 = tmp0_serialDesc;
  }
  protoOf($serializer).zwu = function (encoder, value) {
    var tmp0_desc = this.ywu_1;
    var tmp1_output = encoder.n74(tmp0_desc);
    tmp1_output.c76(tmp0_desc, 0, value.awv_1);
    if (tmp1_output.k76(tmp0_desc, 1) ? true : !(value.bwv_1 == null)) {
      tmp1_output.g76(tmp0_desc, 1, StringSerializer_getInstance(), value.bwv_1);
    }
    if (tmp1_output.k76(tmp0_desc, 2) ? true : !(value.cwv_1 == null)) {
      tmp1_output.g76(tmp0_desc, 2, JsonElementSerializer_getInstance(), value.cwv_1);
    }
    if (tmp1_output.k76(tmp0_desc, 3) ? true : !(value.dwv_1 == null)) {
      tmp1_output.g76(tmp0_desc, 3, StringSerializer_getInstance(), value.dwv_1);
    }
    tmp1_output.o74(tmp0_desc);
  };
  protoOf($serializer).z70 = function (encoder, value) {
    return this.zwu(encoder, value instanceof PostgrestErrorResponse ? value : THROW_CCE());
  };
  protoOf($serializer).a71 = function (decoder) {
    var tmp0_desc = this.ywu_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.n74(tmp0_desc);
    if (tmp8_input.d75()) {
      tmp4_local0 = tmp8_input.x74(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.b75(tmp0_desc, 2, JsonElementSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.e75(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.x74(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.b75(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.b75(tmp0_desc, 2, JsonElementSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.b75(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.o74(tmp0_desc);
    return PostgrestErrorResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer).y70 = function () {
    return this.ywu_1;
  };
  protoOf($serializer).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(JsonElementSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function PostgrestErrorResponse_init_$Init$(seen0, message, hint, details, code, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().ywu_1);
    }
    $this.awv_1 = message;
    if (0 === (seen0 & 2))
      $this.bwv_1 = null;
    else
      $this.bwv_1 = hint;
    if (0 === (seen0 & 4))
      $this.cwv_1 = null;
    else
      $this.cwv_1 = details;
    if (0 === (seen0 & 8))
      $this.dwv_1 = null;
    else
      $this.dwv_1 = code;
    return $this;
  }
  function PostgrestErrorResponse_init_$Create$(seen0, message, hint, details, code, serializationConstructorMarker) {
    return PostgrestErrorResponse_init_$Init$(seen0, message, hint, details, code, serializationConstructorMarker, objectCreate(protoOf(PostgrestErrorResponse)));
  }
  function PostgrestErrorResponse(message, hint, details, code) {
    hint = hint === VOID ? null : hint;
    details = details === VOID ? null : details;
    code = code === VOID ? null : code;
    this.awv_1 = message;
    this.bwv_1 = hint;
    this.cwv_1 = details;
    this.dwv_1 = code;
  }
  protoOf(PostgrestErrorResponse).toString = function () {
    return 'PostgrestErrorResponse(message=' + this.awv_1 + ', hint=' + this.bwv_1 + ', details=' + toString_0(this.cwv_1) + ', code=' + this.dwv_1 + ')';
  };
  protoOf(PostgrestErrorResponse).hashCode = function () {
    var result = getStringHashCode(this.awv_1);
    result = imul(result, 31) + (this.bwv_1 == null ? 0 : getStringHashCode(this.bwv_1)) | 0;
    result = imul(result, 31) + (this.cwv_1 == null ? 0 : hashCode(this.cwv_1)) | 0;
    result = imul(result, 31) + (this.dwv_1 == null ? 0 : getStringHashCode(this.dwv_1)) | 0;
    return result;
  };
  protoOf(PostgrestErrorResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PostgrestErrorResponse))
      return false;
    if (!(this.awv_1 === other.awv_1))
      return false;
    if (!(this.bwv_1 == other.bwv_1))
      return false;
    if (!equals(this.cwv_1, other.cwv_1))
      return false;
    if (!(this.dwv_1 == other.dwv_1))
      return false;
    return true;
  };
  function PostgrestImpl$api$lambda$lambda(this$0) {
    return function ($this$timeout) {
      $this$timeout.fui(_Duration___get_inWholeMilliseconds__impl__msfiry(this$0.fwv_1.qwu_1));
      return Unit_instance;
    };
  }
  function PostgrestImpl$api$lambda(this$0) {
    return function ($this$withDefaultRequest) {
      timeout($this$withDefaultRequest, PostgrestImpl$api$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function $parseErrorResponseCOROUTINE$(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qwv_1 = _this__u8e3s4;
    this.rwv_1 = response;
  }
  protoOf($parseErrorResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var this_0 = this.rwv_1;
            this.n9_1 = 1;
            suspendResult = bodyAsText(this_0, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.twv_1 = suspendResult;
            this.o9_1 = 2;
            var tmp_0 = this;
            var tmp0 = get_supabaseJson();
            var string = this.twv_1;
            var this_1 = tmp0.c75();
            var this_2 = serializer(this_1, createKType(getKClass(PostgrestErrorResponse), arrayOf([]), false));
            tmp_0.swv_1 = tmp0.c72(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof SerializationException) {
              var e = this.q9_1;
              var tmp_2 = this;
              var tmp0_0 = Companion_getInstance_0().evj_1;
              var level = LogLevel_INFO_getInstance();
              var tmp0_elvis_lhs = tmp0_0.fsu();
              if (level.i3(tmp0_elvis_lhs == null ? Companion_getInstance_0().dvj_1 : tmp0_elvis_lhs) >= 0) {
                tmp0_0.fvj(level, e, 'Could not decode ' + this.twv_1 + ' as ' + toString(getKClass(PostgrestErrorResponse)) + '.');
              }
              tmp_2.swv_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            var tmp0_elvis_lhs_0 = this.swv_1;
            var body = tmp0_elvis_lhs_0 == null ? new PostgrestErrorResponse('Unknown error') : tmp0_elvis_lhs_0;
            return new PostgrestRestException(body.awv_1, body.bwv_1, body.cwv_1, body.dwv_1, this.rwv_1);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function PostgrestImpl(supabaseClient, config) {
    this.ewv_1 = supabaseClient;
    this.fwv_1 = config;
    var tmp = this;
    var tmp0_elvis_lhs = this.fwv_1.rwu_1;
    tmp.gwv_1 = tmp0_elvis_lhs == null ? this.ewv_1.wvj() : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp_1 = authenticatedSupabaseApi(this.ewv_1, this, VOID, VOID, this.fwv_1.pwu_1);
    tmp_0.hwv_1 = tmp_1.cwg(PostgrestImpl$api$lambda(this));
  }
  protoOf(PostgrestImpl).yvn = function () {
    return this.ewv_1;
  };
  protoOf(PostgrestImpl).ebw = function () {
    return this.fwv_1;
  };
  protoOf(PostgrestImpl).tvn = function () {
    return 1;
  };
  protoOf(PostgrestImpl).uvn = function () {
    return Companion_getInstance_3().swu_1;
  };
  protoOf(PostgrestImpl).rvz = function () {
    return this.gwv_1;
  };
  protoOf(PostgrestImpl).xwu = function (table) {
    return new PostgrestQueryBuilder(this, table);
  };
  protoOf(PostgrestImpl).svn = function (response, $completion) {
    var tmp = new $parseErrorResponseCOROUTINE$(this, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0(function_0) {
    this.uwv_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0).q3 = function () {
    return this.uwv_1;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PropertyConversionMethod) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0(function_0) {
    this.vwv_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0).q3 = function () {
    return this.vwv_1;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PropertyConversionMethod) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1(function_0) {
    this.wwv_1 = function_0;
  }
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1).q3 = function () {
    return this.wwv_1;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PropertyConversionMethod) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function PropertyConversionMethod$Companion$SERIAL_NAME$lambda(it) {
    return getSerialName(it);
  }
  function PropertyConversionMethod$Companion$CAMEL_CASE_TO_SNAKE_CASE$lambda(it) {
    return camelToSnakeCase(it.callableName);
  }
  function PropertyConversionMethod$Companion$NONE$lambda(it) {
    return it.callableName;
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp_0 = PropertyConversionMethod$Companion$SERIAL_NAME$lambda;
    tmp.hwu_1 = new sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0(tmp_0);
    var tmp_1 = this;
    var tmp_2 = PropertyConversionMethod$Companion$CAMEL_CASE_TO_SNAKE_CASE$lambda;
    tmp_1.iwu_1 = new sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_0(tmp_2);
    var tmp_3 = this;
    var tmp_4 = PropertyConversionMethod$Companion$NONE$lambda;
    tmp_3.jwu_1 = new sam$io_github_jan_supabase_postgrest_PropertyConversionMethod$0_1(tmp_4);
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function PropertyConversionMethod() {
  }
  function get_SNAKE_CASE_REGEX() {
    _init_properties_Utils_kt__jo07cx();
    return SNAKE_CASE_REGEX;
  }
  var SNAKE_CASE_REGEX;
  function mapToFirstValue(_this__u8e3s4) {
    _init_properties_Utils_kt__jo07cx();
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$(mapCapacity(_this__u8e3s4.n1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = _this__u8e3s4.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = element.t1();
      var tmp$ret$4 = first(element.u1());
      destination.z2(tmp, tmp$ret$4);
    }
    return destination;
  }
  function camelToSnakeCase(_this__u8e3s4) {
    _init_properties_Utils_kt__jo07cx();
    // Inline function 'kotlin.text.replace' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    return get_SNAKE_CASE_REGEX().de(_this__u8e3s4, '$1_$2').toLowerCase();
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      // Inline function 'kotlin.text.toRegex' call
      var this_0 = '([a-z0-9])([A-Z])';
      SNAKE_CASE_REGEX = Regex_init_$Create$(this_0);
    }
  }
  function PostgrestRestException(message, hint, details, code, response) {
    RestException.call(this, message, trimIndent('\n    Code: ' + code + '\n    Hint: ' + hint + '\n    Details: ' + toString_0(details) + '\n'), response);
    captureStack(this, PostgrestRestException);
    this.bww_1 = hint;
    this.cww_1 = details;
    this.dww_1 = code;
  }
  function asPostgrestResult(_this__u8e3s4, postgrest, $completion) {
    var tmp = new $asPostgrestResultCOROUTINE$(_this__u8e3s4, postgrest, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function configurePostgrestRequest(_this__u8e3s4, request) {
    _this__u8e3s4.ztr_1 = request.ntt();
    contentType(_this__u8e3s4, Application_getInstance().ksv_1);
    _this__u8e3s4.ats_1.gsq(request.dt2());
    _this__u8e3s4.ats_1.dsq('Prefer', joinToString(request.oww(), ','));
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.ytr_1.qt5_1;
    // Inline function 'kotlin.collections.mapValues' call
    var this_0 = request.pww();
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap_init_$Create$(mapCapacity(this_0.n1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = this_0.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.u1();
      var tmp$ret$6 = listOf(value);
      destination.z2(tmp, tmp$ret$6);
    }
    $this$with.gsq(parametersOf(destination));
    var tmp_0 = request.qww();
    if (tmp_0 instanceof Representation) {
      var tmp_1 = request.qww();
      $this$with.fsq('select', _Columns___get_value__impl__haxhww((tmp_1 instanceof Representation ? tmp_1 : THROW_CCE()).sww_1));
    }
    var tmp0_safe_receiver = request.tww();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'io.ktor.client.request.setBody' call
      if (tmp0_safe_receiver == null) {
        _this__u8e3s4.bts_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_2 = getKClass(JsonElement);
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_3;
        try {
          tmp_3 = createKType(getKClass(JsonElement), arrayOf([]), false);
        } catch ($p) {
          var tmp_4;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_4 = null;
          } else {
            throw $p;
          }
          tmp_3 = tmp_4;
        }
        var tmp$ret$12 = tmp_3;
        var tmp$ret$11 = new TypeInfo(tmp_2, tmp$ret$12);
        _this__u8e3s4.qtx(tmp$ret$11);
      } else {
        if (tmp0_safe_receiver instanceof OutgoingContent) {
          _this__u8e3s4.bts_1 = tmp0_safe_receiver;
          _this__u8e3s4.qtx(null);
        } else {
          _this__u8e3s4.bts_1 = tmp0_safe_receiver;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_5 = getKClass(JsonElement);
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_6;
          try {
            tmp_6 = createKType(getKClass(JsonElement), arrayOf([]), false);
          } catch ($p_0) {
            var tmp_7;
            if ($p_0 instanceof Error) {
              var _unused_var__etf5q3_0 = $p_0;
              tmp_7 = null;
            } else {
              throw $p_0;
            }
            tmp_6 = tmp_7;
          }
          var tmp$ret$14 = tmp_6;
          var tmp$ret$13 = new TypeInfo(tmp_5, tmp$ret$14);
          _this__u8e3s4.qtx(tmp$ret$13);
        }
      }
    }
    // Inline function 'kotlin.text.isNotBlank' call
    var this_1 = request.uww();
    if (!isBlank(this_1)) {
      var tmp1_subject = _this__u8e3s4.ztr_1;
      if (tmp1_subject.equals(Companion_getInstance_1().et2_1) || tmp1_subject.equals(Companion_getInstance_1().jt2_1)) {
        header(_this__u8e3s4, 'Accept-Profile', request.uww());
      } else {
        header(_this__u8e3s4, 'Content-Profile', request.uww());
      }
    }
  }
  function $asPostgrestResultCOROUTINE$(_this__u8e3s4, postgrest, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mww_1 = _this__u8e3s4;
    this.nww_1 = postgrest;
  }
  protoOf($asPostgrestResultCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = bodyAsText(this.mww_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new PostgrestResult(ARGUMENT, this.mww_1.dt2(), this.nww_1);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function RestRequestExecutor$execute$lambda($request) {
    return function ($this$request) {
      configurePostgrestRequest($this$request, $request);
      return Unit_instance;
    };
  }
  function $executeCOROUTINE$(_this__u8e3s4, postgrest, path, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dwx_1 = _this__u8e3s4;
    this.ewx_1 = postgrest;
    this.fwx_1 = path;
    this.gwx_1 = request;
  }
  protoOf($executeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this.ewx_1;
            var authenticatedSupabaseApi = (tmp_0 instanceof PostgrestImpl ? tmp_0 : THROW_CCE()).hwv_1;
            this.n9_1 = 1;
            suspendResult = authenticatedSupabaseApi.wvm(this.fwx_1, RestRequestExecutor$execute$lambda(this.gwx_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = asPostgrestResult(ARGUMENT, this.ewx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function RestRequestExecutor() {
  }
  protoOf(RestRequestExecutor).hwx = function (postgrest, path, request, $completion) {
    var tmp = new $executeCOROUTINE$(this, postgrest, path, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RestRequestExecutor).toString = function () {
    return 'RestRequestExecutor';
  };
  protoOf(RestRequestExecutor).hashCode = function () {
    return -105643338;
  };
  protoOf(RestRequestExecutor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RestRequestExecutor))
      return false;
    return true;
  };
  var RestRequestExecutor_instance;
  function RestRequestExecutor_getInstance() {
    return RestRequestExecutor_instance;
  }
  function _Columns___init__impl__mew5p8(value) {
    return value;
  }
  function _Columns___get_value__impl__haxhww($this) {
    return $this;
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.iwx_1 = _Columns___init__impl__mew5p8('*');
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function Columns__toString_impl_ncnq70($this) {
    return 'Columns(value=' + $this + ')';
  }
  function Columns__hashCode_impl_pxaez9($this) {
    return getStringHashCode($this);
  }
  function Columns__equals_impl_9n1b0v($this, other) {
    if (!(other instanceof Columns))
      return false;
    if (!($this === other.jwx_1))
      return false;
    return true;
  }
  function Columns(value) {
    Companion_getInstance_6();
    this.jwx_1 = value;
  }
  protoOf(Columns).toString = function () {
    return Columns__toString_impl_ncnq70(this.jwx_1);
  };
  protoOf(Columns).hashCode = function () {
    return Columns__hashCode_impl_pxaez9(this.jwx_1);
  };
  protoOf(Columns).equals = function (other) {
    return Columns__equals_impl_9n1b0v(this.jwx_1, other);
  };
  var Order_ASCENDING_instance;
  var Order_DESCENDING_instance;
  var Order_entriesInitialized;
  function Order_initEntries() {
    if (Order_entriesInitialized)
      return Unit_instance;
    Order_entriesInitialized = true;
    Order_ASCENDING_instance = new Order('ASCENDING', 0, 'asc');
    Order_DESCENDING_instance = new Order('DESCENDING', 1, 'desc');
  }
  function Order(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.mwx_1 = value;
  }
  function Order_DESCENDING_getInstance() {
    Order_initEntries();
    return Order_DESCENDING_instance;
  }
  function Companion_3() {
    this.nwx_1 = 'Prefer';
  }
  var Companion_instance_3;
  function Companion_getInstance_7() {
    return Companion_instance_3;
  }
  function PostgrestQueryBuilder(postgrest, table, schema) {
    schema = schema === VOID ? postgrest.ebw().mwu_1 : schema;
    this.owx_1 = postgrest;
    this.pwx_1 = table;
    this.qwx_1 = schema;
  }
  function Minimal() {
    Minimal_instance = this;
    Returning.call(this, 'minimal');
  }
  protoOf(Minimal).toString = function () {
    return 'Minimal';
  };
  protoOf(Minimal).hashCode = function () {
    return -1374471108;
  };
  protoOf(Minimal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Minimal))
      return false;
    return true;
  };
  var Minimal_instance;
  function Minimal_getInstance() {
    if (Minimal_instance == null)
      new Minimal();
    return Minimal_instance;
  }
  function Representation(columns) {
    columns = columns === VOID ? Companion_getInstance_6().iwx_1 : columns;
    Returning.call(this, 'representation');
    this.sww_1 = columns;
  }
  protoOf(Representation).toString = function () {
    return 'Representation(columns=' + Columns__toString_impl_ncnq70(this.sww_1) + ')';
  };
  protoOf(Representation).hashCode = function () {
    return Columns__hashCode_impl_pxaez9(this.sww_1);
  };
  protoOf(Representation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Representation))
      return false;
    if (!(this.sww_1 === other.sww_1))
      return false;
    return true;
  };
  function Returning(identifier) {
    this.rwx_1 = identifier;
  }
  function PostgrestRequestBuilder(propertyConversionMethod) {
    this.swx_1 = propertyConversionMethod;
    this.twx_1 = null;
    this.uwx_1 = Minimal_getInstance();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.vwx_1 = LinkedHashMap_init_$Create$_0();
    this.wwx_1 = new HeadersBuilder();
  }
  protoOf(PostgrestRequestBuilder).xwx = function (columns) {
    this.uwx_1 = new Representation(columns);
  };
  protoOf(PostgrestRequestBuilder).ywx = function (columns, $super) {
    columns = columns === VOID ? Companion_getInstance_6().iwx_1 : columns;
    var tmp;
    if ($super === VOID) {
      this.xwx(columns);
      tmp = Unit_instance;
    } else {
      tmp = $super.xwx.call(this, new Columns(columns));
    }
    return tmp;
  };
  protoOf(PostgrestRequestBuilder).singleValue = function () {
    this.wwx_1.dsq('Accept', 'application/vnd.pgrst.object+json');
  };
  protoOf(PostgrestRequestBuilder).zwx = function (column, order, nullsFirst, referencedTable) {
    var key = referencedTable == null ? 'order' : referencedTable + '.order';
    var tmp0_safe_receiver = this.vwx_1.w2(key);
    var orderEntry = tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
    var existingOrder = orderEntry == null ? '' : orderEntry + ',';
    var newOrder = existingOrder + column + '.' + order.mwx_1 + '.' + (nullsFirst ? 'nullsfirst' : 'nullslast');
    var tmp0 = this.vwx_1;
    // Inline function 'kotlin.collections.set' call
    var value = listOf(newOrder);
    tmp0.z2(key, value);
  };
  protoOf(PostgrestRequestBuilder).awy = function (column, order, nullsFirst, referencedTable, $super) {
    nullsFirst = nullsFirst === VOID ? false : nullsFirst;
    referencedTable = referencedTable === VOID ? null : referencedTable;
    var tmp;
    if ($super === VOID) {
      this.zwx(column, order, nullsFirst, referencedTable);
      tmp = Unit_instance;
    } else {
      tmp = $super.zwx.call(this, column, order, nullsFirst, referencedTable);
    }
    return tmp;
  };
  function get_quotedCharacters() {
    _init_properties_FilterOperation_kt__4boen1();
    return quotedCharacters;
  }
  var quotedCharacters;
  function FilterOperation(column, operator, value) {
    this.bwy_1 = column;
    this.cwy_1 = operator;
    this.dwy_1 = value;
  }
  protoOf(FilterOperation).toString = function () {
    return 'FilterOperation(column=' + this.bwy_1 + ', operator=' + this.cwy_1.toString() + ', value=' + toString_0(this.dwy_1) + ')';
  };
  protoOf(FilterOperation).hashCode = function () {
    var result = getStringHashCode(this.bwy_1);
    result = imul(result, 31) + this.cwy_1.hashCode() | 0;
    result = imul(result, 31) + (this.dwy_1 == null ? 0 : hashCode(this.dwy_1)) | 0;
    return result;
  };
  protoOf(FilterOperation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FilterOperation))
      return false;
    if (!(this.bwy_1 === other.bwy_1))
      return false;
    if (!this.cwy_1.equals(other.cwy_1))
      return false;
    if (!equals(this.dwy_1, other.dwy_1))
      return false;
    return true;
  };
  function escapedValue(_this__u8e3s4, isInLogicalExpression) {
    _init_properties_FilterOperation_kt__4boen1();
    var tmp;
    switch (_this__u8e3s4.cwy_1.a1_1) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 8:
      case 7:
      case 9:
      case 10:
      case 20:
      case 23:
      case 22:
      case 21:
        tmp = isInLogicalExpression ? escapeValue(_this__u8e3s4.dwy_1) : toString_0(_this__u8e3s4.dwy_1);
        break;
      case 11:
        var tmp_0;
        var tmp_1 = _this__u8e3s4.dwy_1;
        if (!(tmp_1 == null) ? isInterface(tmp_1, KtList) : false) {
          tmp_0 = encodeAsList(_this__u8e3s4.dwy_1);
        } else {
          tmp_0 = escapeValue(_this__u8e3s4.dwy_1);
        }

        tmp = tmp_0;
        break;
      case 12:
      case 13:
      case 19:
        var tmp1_subject = _this__u8e3s4.dwy_1;
        var tmp_2;
        if (!(tmp1_subject == null) ? isInterface(tmp1_subject, KtList) : false) {
          tmp_2 = encodeOverlapAsArray(_this__u8e3s4.dwy_1);
        } else {
          if (tmp1_subject instanceof Pair) {
            tmp_2 = encodeOverlapAsRange(_this__u8e3s4.dwy_1);
          } else {
            tmp_2 = isInLogicalExpression ? escapeValue(_this__u8e3s4.dwy_1) : toString_0(_this__u8e3s4.dwy_1);
          }
        }

        tmp = tmp_2;
        break;
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
        var tmp2_subject = _this__u8e3s4.dwy_1;
        var tmp_3;
        if (tmp2_subject instanceof Pair) {
          tmp_3 = encodeAsRange(_this__u8e3s4.dwy_1);
        } else {
          if (!(tmp2_subject == null) ? isInterface(tmp2_subject, KtList) : false) {
            tmp_3 = encodeAsRange_0(_this__u8e3s4.dwy_1);
          } else {
            tmp_3 = escapeValue(_this__u8e3s4.dwy_1);
          }
        }

        tmp = tmp_3;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function escapeValue(value) {
    _init_properties_FilterOperation_kt__4boen1();
    var asString = replace(replace(toString_0(value), '\\', '\\\\'), '"', '\\"');
    var tmp;
    var tmp0 = get_quotedCharacters();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.r();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (contains(asString, element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp = '"' + asString + '"';
    } else {
      tmp = asString;
    }
    return tmp;
  }
  function encodeAsList(values) {
    _init_properties_FilterOperation_kt__4boen1();
    return joinToString(values, ',', '(', ')', VOID, VOID, encodeAsList$lambda);
  }
  function encodeOverlapAsArray(values) {
    _init_properties_FilterOperation_kt__4boen1();
    return joinToString(values, ',', '{', '}');
  }
  function encodeOverlapAsRange(range) {
    _init_properties_FilterOperation_kt__4boen1();
    return '[' + toString_0(range.xh_1) + ',' + toString_0(range.yh_1) + ']';
  }
  function encodeAsRange(range) {
    _init_properties_FilterOperation_kt__4boen1();
    return '(' + toString_0(range.xh_1) + ',' + toString_0(range.yh_1) + ')';
  }
  function encodeAsRange_0(range) {
    _init_properties_FilterOperation_kt__4boen1();
    return '(' + toString_0(range.l1(0)) + ',' + toString_0(range.l1(1)) + ')';
  }
  function encodeAsList$lambda(it) {
    _init_properties_FilterOperation_kt__4boen1();
    return escapeValue(it);
  }
  var properties_initialized_FilterOperation_kt_nafb6p;
  function _init_properties_FilterOperation_kt__4boen1() {
    if (!properties_initialized_FilterOperation_kt_nafb6p) {
      properties_initialized_FilterOperation_kt_nafb6p = true;
      quotedCharacters = listOf_0([',', '.', ':', '(', ')']);
    }
  }
  var FilterOperator_EQ_instance;
  var FilterOperator_NEQ_instance;
  var FilterOperator_GT_instance;
  var FilterOperator_GTE_instance;
  var FilterOperator_LT_instance;
  var FilterOperator_LTE_instance;
  var FilterOperator_LIKE_instance;
  var FilterOperator_MATCH_instance;
  var FilterOperator_ILIKE_instance;
  var FilterOperator_IMATCH_instance;
  var FilterOperator_IS_instance;
  var FilterOperator_IN_instance;
  var FilterOperator_CS_instance;
  var FilterOperator_CD_instance;
  var FilterOperator_SL_instance;
  var FilterOperator_SR_instance;
  var FilterOperator_NXL_instance;
  var FilterOperator_NXR_instance;
  var FilterOperator_ADJ_instance;
  var FilterOperator_OV_instance;
  var FilterOperator_FTS_instance;
  var FilterOperator_PLFTS_instance;
  var FilterOperator_PHFTS_instance;
  var FilterOperator_WFTS_instance;
  var FilterOperator_entriesInitialized;
  function FilterOperator_initEntries() {
    if (FilterOperator_entriesInitialized)
      return Unit_instance;
    FilterOperator_entriesInitialized = true;
    FilterOperator_EQ_instance = new FilterOperator('EQ', 0, 'eq');
    FilterOperator_NEQ_instance = new FilterOperator('NEQ', 1, 'neq');
    FilterOperator_GT_instance = new FilterOperator('GT', 2, 'gt');
    FilterOperator_GTE_instance = new FilterOperator('GTE', 3, 'gte');
    FilterOperator_LT_instance = new FilterOperator('LT', 4, 'lt');
    FilterOperator_LTE_instance = new FilterOperator('LTE', 5, 'lte');
    FilterOperator_LIKE_instance = new FilterOperator('LIKE', 6, 'like');
    FilterOperator_MATCH_instance = new FilterOperator('MATCH', 7, 'match');
    FilterOperator_ILIKE_instance = new FilterOperator('ILIKE', 8, 'ilike');
    FilterOperator_IMATCH_instance = new FilterOperator('IMATCH', 9, 'imatch');
    FilterOperator_IS_instance = new FilterOperator('IS', 10, 'is');
    FilterOperator_IN_instance = new FilterOperator('IN', 11, 'in');
    FilterOperator_CS_instance = new FilterOperator('CS', 12, 'cs');
    FilterOperator_CD_instance = new FilterOperator('CD', 13, 'cd');
    FilterOperator_SL_instance = new FilterOperator('SL', 14, 'sl');
    FilterOperator_SR_instance = new FilterOperator('SR', 15, 'sr');
    FilterOperator_NXL_instance = new FilterOperator('NXL', 16, 'nxl');
    FilterOperator_NXR_instance = new FilterOperator('NXR', 17, 'nxr');
    FilterOperator_ADJ_instance = new FilterOperator('ADJ', 18, 'adj');
    FilterOperator_OV_instance = new FilterOperator('OV', 19, 'ov');
    FilterOperator_FTS_instance = new FilterOperator('FTS', 20, 'fts');
    FilterOperator_PLFTS_instance = new FilterOperator('PLFTS', 21, 'plfts');
    FilterOperator_PHFTS_instance = new FilterOperator('PHFTS', 22, 'phfts');
    FilterOperator_WFTS_instance = new FilterOperator('WFTS', 23, 'wfts');
  }
  function FilterOperator(name, ordinal, identifier) {
    Enum.call(this, name, ordinal);
    this.gwy_1 = identifier;
  }
  function FilterOperator_EQ_getInstance() {
    FilterOperator_initEntries();
    return FilterOperator_EQ_instance;
  }
  function FilterOperator_NEQ_getInstance() {
    FilterOperator_initEntries();
    return FilterOperator_NEQ_instance;
  }
  function FilterOperator_IN_getInstance() {
    FilterOperator_initEntries();
    return FilterOperator_IN_instance;
  }
  function PostgrestFilterBuilder(propertyConversionMethod, _params, isInLogicalExpression) {
    var tmp;
    if (_params === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$_0();
    } else {
      tmp = _params;
    }
    _params = tmp;
    isInLogicalExpression = isInLogicalExpression === VOID ? false : isInLogicalExpression;
    this.hwy_1 = propertyConversionMethod;
    this.iwy_1 = _params;
    this.jwy_1 = isInLogicalExpression;
  }
  protoOf(PostgrestFilterBuilder).kwy = function () {
    return toMap(this.iwy_1);
  };
  protoOf(PostgrestFilterBuilder).lwy = function (column, operator, value) {
    this.mwy(new FilterOperation(column, operator, value));
  };
  protoOf(PostgrestFilterBuilder).mwy = function (operation) {
    var tmp0_elvis_lhs = this.kwy().w2(operation.bwy_1);
    var columnValue = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp0 = this.iwy_1;
    var tmp2 = operation.bwy_1;
    // Inline function 'kotlin.collections.set' call
    var value = plus(columnValue, listOf(operation.cwy_1.gwy_1 + '.' + escapedValue(operation, this.jwy_1)));
    tmp0.z2(tmp2, value);
  };
  protoOf(PostgrestFilterBuilder).nwy = function (column, value) {
    return this.lwy(column, FilterOperator_EQ_getInstance(), value);
  };
  protoOf(PostgrestFilterBuilder).owy = function (column, value) {
    return this.lwy(column, FilterOperator_NEQ_getInstance(), value);
  };
  protoOf(PostgrestFilterBuilder).pwy = function (column, values) {
    return this.lwy(column, FilterOperator_IN_getInstance(), values);
  };
  function InsertRequestBuilder(propertyConversionMethod) {
    PostgrestRequestBuilder.call(this, propertyConversionMethod);
    this.vwy_1 = true;
  }
  function SelectRequestBuilder(propertyConversionMethod) {
    PostgrestRequestBuilder.call(this, propertyConversionMethod);
    this.bwz_1 = false;
  }
  function UpsertRequestBuilder(propertyConversionMethod) {
    InsertRequestBuilder.call(this, propertyConversionMethod);
    this.iwz_1 = null;
    this.jwz_1 = false;
  }
  function DeleteRequest(returning, count, urlParams, schema, headers) {
    returning = returning === VOID ? Minimal_getInstance() : returning;
    count = count === VOID ? null : count;
    headers = headers === VOID ? Companion_getInstance_2().yt1_1 : headers;
    this.kwz_1 = returning;
    this.lwz_1 = count;
    this.mwz_1 = urlParams;
    this.nwz_1 = schema;
    this.owz_1 = headers;
    this.pwz_1 = Companion_getInstance_1().it2_1;
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.j1('return=' + this.kwz_1.rwx_1);
    if (!(this.lwz_1 == null)) {
      this_0.j1('count=' + this.lwz_1.twz_1);
    }
    tmp.qwz_1 = this_0.t5();
  }
  protoOf(DeleteRequest).qww = function () {
    return this.kwz_1;
  };
  protoOf(DeleteRequest).pww = function () {
    return this.mwz_1;
  };
  protoOf(DeleteRequest).uww = function () {
    return this.nwz_1;
  };
  protoOf(DeleteRequest).dt2 = function () {
    return this.owz_1;
  };
  protoOf(DeleteRequest).ntt = function () {
    return this.pwz_1;
  };
  protoOf(DeleteRequest).oww = function () {
    return this.qwz_1;
  };
  function InsertRequest(upsert, returning, count, ignoreDuplicates, defaultToNull, body, urlParams, schema, headers) {
    upsert = upsert === VOID ? false : upsert;
    returning = returning === VOID ? Minimal_getInstance() : returning;
    count = count === VOID ? null : count;
    ignoreDuplicates = ignoreDuplicates === VOID ? false : ignoreDuplicates;
    defaultToNull = defaultToNull === VOID ? false : defaultToNull;
    headers = headers === VOID ? Companion_getInstance_2().yt1_1 : headers;
    this.uwz_1 = upsert;
    this.vwz_1 = returning;
    this.wwz_1 = count;
    this.xwz_1 = ignoreDuplicates;
    this.ywz_1 = defaultToNull;
    this.zwz_1 = body;
    this.ax0_1 = urlParams;
    this.bx0_1 = schema;
    this.cx0_1 = headers;
    this.dx0_1 = Companion_getInstance_1().ft2_1;
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.j1('return=' + this.vwz_1.rwx_1);
    if (this.uwz_1) {
      this_0.j1('resolution=' + (this.xwz_1 ? 'ignore' : 'merge') + '-duplicates');
    }
    if (!this.ywz_1) {
      this_0.j1('missing=default');
    }
    if (!(this.wwz_1 == null)) {
      this_0.j1('count=' + this.wwz_1.twz_1);
    }
    tmp.ex0_1 = this_0.t5();
  }
  protoOf(InsertRequest).qww = function () {
    return this.vwz_1;
  };
  protoOf(InsertRequest).tww = function () {
    return this.zwz_1;
  };
  protoOf(InsertRequest).pww = function () {
    return this.ax0_1;
  };
  protoOf(InsertRequest).uww = function () {
    return this.bx0_1;
  };
  protoOf(InsertRequest).dt2 = function () {
    return this.cx0_1;
  };
  protoOf(InsertRequest).ntt = function () {
    return this.dx0_1;
  };
  protoOf(InsertRequest).oww = function () {
    return this.ex0_1;
  };
  protoOf(InsertRequest).toString = function () {
    return 'InsertRequest(upsert=' + this.uwz_1 + ', returning=' + toString(this.vwz_1) + ', count=' + toString_0(this.wwz_1) + ', ignoreDuplicates=' + this.xwz_1 + ', defaultToNull=' + this.ywz_1 + ', body=' + this.zwz_1.toString() + ', urlParams=' + toString(this.ax0_1) + ', schema=' + this.bx0_1 + ', headers=' + toString(this.cx0_1) + ')';
  };
  protoOf(InsertRequest).hashCode = function () {
    var result = getBooleanHashCode(this.uwz_1);
    result = imul(result, 31) + hashCode(this.vwz_1) | 0;
    result = imul(result, 31) + (this.wwz_1 == null ? 0 : this.wwz_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.xwz_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ywz_1) | 0;
    result = imul(result, 31) + this.zwz_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ax0_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.bx0_1) | 0;
    result = imul(result, 31) + hashCode(this.cx0_1) | 0;
    return result;
  };
  protoOf(InsertRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InsertRequest))
      return false;
    if (!(this.uwz_1 === other.uwz_1))
      return false;
    if (!equals(this.vwz_1, other.vwz_1))
      return false;
    if (!equals(this.wwz_1, other.wwz_1))
      return false;
    if (!(this.xwz_1 === other.xwz_1))
      return false;
    if (!(this.ywz_1 === other.ywz_1))
      return false;
    if (!this.zwz_1.equals(other.zwz_1))
      return false;
    if (!equals(this.ax0_1, other.ax0_1))
      return false;
    if (!(this.bx0_1 === other.bx0_1))
      return false;
    if (!equals(this.cx0_1, other.cx0_1))
      return false;
    return true;
  };
  function PostgrestRequest() {
  }
  function SelectRequest(head, count, urlParams, schema, headers) {
    head = head === VOID ? false : head;
    count = count === VOID ? null : count;
    headers = headers === VOID ? Companion_getInstance_2().yt1_1 : headers;
    this.fx0_1 = head;
    this.gx0_1 = count;
    this.hx0_1 = urlParams;
    this.ix0_1 = schema;
    this.jx0_1 = headers;
    this.kx0_1 = this.fx0_1 ? Companion_getInstance_1().jt2_1 : Companion_getInstance_1().et2_1;
    var tmp = this;
    var tmp_0;
    if (!(this.gx0_1 == null)) {
      tmp_0 = listOf('count=' + this.gx0_1.twz_1);
    } else {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    }
    tmp.lx0_1 = tmp_0;
  }
  protoOf(SelectRequest).pww = function () {
    return this.hx0_1;
  };
  protoOf(SelectRequest).uww = function () {
    return this.ix0_1;
  };
  protoOf(SelectRequest).dt2 = function () {
    return this.jx0_1;
  };
  protoOf(SelectRequest).ntt = function () {
    return this.kx0_1;
  };
  protoOf(SelectRequest).oww = function () {
    return this.lx0_1;
  };
  function UpdateRequest(returning, count, urlParams, body, schema, headers) {
    returning = returning === VOID ? Minimal_getInstance() : returning;
    count = count === VOID ? null : count;
    headers = headers === VOID ? Companion_getInstance_2().yt1_1 : headers;
    this.mx0_1 = returning;
    this.nx0_1 = count;
    this.ox0_1 = urlParams;
    this.px0_1 = body;
    this.qx0_1 = schema;
    this.rx0_1 = headers;
    this.sx0_1 = Companion_getInstance_1().ht2_1;
    var tmp = this;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    this_0.j1('return=' + this.mx0_1.rwx_1);
    if (!(this.nx0_1 == null)) {
      this_0.j1('count=' + this.nx0_1.twz_1);
    }
    tmp.tx0_1 = this_0.t5();
  }
  protoOf(UpdateRequest).qww = function () {
    return this.mx0_1;
  };
  protoOf(UpdateRequest).pww = function () {
    return this.ox0_1;
  };
  protoOf(UpdateRequest).tww = function () {
    return this.px0_1;
  };
  protoOf(UpdateRequest).uww = function () {
    return this.qx0_1;
  };
  protoOf(UpdateRequest).dt2 = function () {
    return this.rx0_1;
  };
  protoOf(UpdateRequest).ntt = function () {
    return this.sx0_1;
  };
  protoOf(UpdateRequest).oww = function () {
    return this.tx0_1;
  };
  function PostgrestResult(data, headers, postgrest) {
    this.ux0_1 = data;
    this.vx0_1 = headers;
    this.wx0_1 = postgrest;
    this.xx0_1 = this.vx0_1.je('Content-Range');
  }
  function getSerialName(property) {
    return property.callableName;
  }
  //region block: post-declaration
  protoOf(Companion).pvl = setup;
  protoOf($serializer).u7c = typeParametersSerializers;
  protoOf(PostgrestImpl).vvn = resolveUrl;
  protoOf(PostgrestImpl).odl = init;
  protoOf(DeleteRequest).tww = get_body;
  protoOf(SelectRequest).tww = get_body;
  protoOf(SelectRequest).qww = get_returning;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  RestRequestExecutor_instance = new RestRequestExecutor();
  Companion_instance_3 = new Companion_3();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = _Columns___get_value__impl__haxhww;
  _.$_$.b = RestRequestExecutor_instance;
  _.$_$.c = Companion_getInstance_6;
  _.$_$.d = Companion_getInstance_3;
  _.$_$.e = Order_DESCENDING_getInstance;
  _.$_$.f = PostgrestFilterBuilder;
  _.$_$.g = InsertRequestBuilder;
  _.$_$.h = SelectRequestBuilder;
  _.$_$.i = UpsertRequestBuilder;
  _.$_$.j = PostgrestRequestBuilder;
  _.$_$.k = DeleteRequest;
  _.$_$.l = InsertRequest;
  _.$_$.m = SelectRequest;
  _.$_$.n = UpdateRequest;
  _.$_$.o = Postgrest;
  _.$_$.p = from;
  _.$_$.q = mapToFirstValue;
  _.$_$.r = get_postgrest;
  //endregion
  return _;
}));

//# sourceMappingURL=supabase-kt-postgrest-kt.js.map
